import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["overlay", "wrapper", "menu"]

  connect() {
    // Ensure menu is closed on connect (after Turbolinks navigation)
    this.closeMenu()
  }

  disconnect() {
    // Clean up on disconnect
    this.closeMenu()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (document.documentElement.classList.contains('menu-opened')) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  openMenu() {
    document.documentElement.classList.add('menu-opened')
    
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('opened')
    }
    
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.add('slide-nav')
    }
  }

  closeMenu() {
    document.documentElement.classList.remove('menu-opened')
    
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('opened')
    }
    
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.remove('slide-nav')
    }
  }

  closeOnOverlay(event) {
    event.preventDefault()
    this.closeMenu()
  }

  closeOnLinkClick(event) {
    // Don't close for dropdown toggles
    const target = event.target
    if (target.classList.contains('dropdown-toggle') || 
        target.closest('.dropdown-toggle') ||
        target.classList.contains('dropdown-item') === false && target.closest('.dropdown-menu')) {
      return
    }
    
    // Close menu after a slight delay to allow navigation
    setTimeout(() => {
      this.closeMenu()
    }, 100)
  }
}
